import React from 'react';
import { Code, Database, Shield, Zap } from 'lucide-react';
import { personalInfo, education } from '../data/mock';
import { Card } from './ui/card';

const About = () => {
  const highlights = [
    {
      icon: <Code size={24} />,
      title: "Backend Development",
      description: "3+ years building scalable APIs with FastAPI, Python & PostgreSQL"
    },
    {
      icon: <Zap size={24} />,
      title: "AI/ML Integration",
      description: "Expert in RASA, Whisper, and LLM integration with production systems"
    },
    {
      icon: <Database size={24} />,
      title: "MLOps & DevOps",
      description: "Docker, CI/CD pipelines, and scalable infrastructure deployment"
    },
    {
      icon: <Shield size={24} />,
      title: "Security Research",
      description: "45+ TryHackMe rooms, penetration testing, and network security"
    }
  ];

  return (
    <section id="about" className="section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About Me</h2>
          <div className="section-underline"></div>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p className="about-summary">{personalInfo.summary}</p>
            <div className="education-card">
              <h3 className="education-title">Education</h3>
              <p className="education-degree">{education.degree}</p>
              <p className="education-institution">{education.institution}</p>
              <p className="education-period">{education.period}</p>
            </div>
          </div>
          <div className="highlights-grid">
            {highlights.map((item, index) => (
              <Card key={index} className="highlight-card">
                <div className="highlight-icon">{item.icon}</div>
                <h3 className="highlight-title">{item.title}</h3>
                <p className="highlight-description">{item.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;